type ListingQueryValue = string | string[] | undefined;

type ListingQueryParams = {
  search?: ListingQueryValue;
  sort?: ListingQueryValue;
  /** @deprecated Pagination page≥2 is indexable with a self-canonical; ignored. */
  page?: ListingQueryValue;
};

/** Sort values that change listing order/composition and must not be indexed. */
export const NOINDEX_LISTING_SORT_VALUES = [
  'bestMonth',
  'newest',
  'popular',
  'best',
  'updated',
] as const;

const NOINDEX_LISTING_SORT_SET = new Set<string>(NOINDEX_LISTING_SORT_VALUES);

const toSingleParam = (value: ListingQueryValue): string => {
  if (Array.isArray(value)) {
    return (
      value.find((entry) => typeof entry === 'string' && entry.trim().length > 0)?.trim() ?? ''
    );
  }
  return typeof value === 'string' ? value.trim() : '';
};

/**
 * Search and non-default sort change the listing surface and must emit
 * noindex, nofollow. Pagination (?page=N, N≥2) stays indexable with a
 * self-canonical (SEO requirement).
 */
export const shouldNoindexListingQuery = (params: ListingQueryParams): boolean => {
  if (toSingleParam(params.search).length > 0) {
    return true;
  }

  const sortValue = toSingleParam(params.sort);
  return NOINDEX_LISTING_SORT_SET.has(sortValue);
};
